import { ModelBase } from "pytha";
/**
 * 特殊设备的类型
 */
export const DeviceModelTypes = ['DvrT', 'SerialT', 'AnemoclinographT', 'MonitorT', 'FluviographT'];

/**
 * 采集箱类型
 */
export const DataBoxModelTypes = ['DvrT', 'SerialT'];

/**
 * 传感器类型
 */
export const SensorModelTypes = ['AnemoclinographT', 'MonitorT', 'FluviographT'];

/**
 * 获取特殊传感器类型的等级
 * @param type 类型
 * @returns 等级
 */
export function getDeviceTypeLevels(type: string) {
    let level = -1;
    if (!DeviceModelTypes.some(i => i === type)) {
        return level;
    }
    if (SensorModelTypes.some(i => i === type)) {
        level = 1;
    } else if (DataBoxModelTypes.some(i => i === type)) {
        level = 2;
    }
    return level;
}

export const DeviceLevelNameDict = {
    1: '传感器',
    2: '采集设备',
}

/**
 * 判断两个图元是否可以连接
 * @param e1 图元1
 * @param e2 图元2
 */
export function checkTwoDeviceCanConnect(e1: ModelBase, e2: ModelBase) {
    if (!e1 || !e2) return [];
    const level1 = getDeviceTypeLevels(e1.type);
    const level2 = getDeviceTypeLevels(e2.type);
    if (Math.abs(level1 - level2) !== 1) return [];
    return level1 < level2 ? [e1, e2] : [e2, e1];
}

export const DeviceLevelTableDict = {
    1: 'sensor',
    2: 'data_box',
}